














































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Car, IdentifierType, InsuranceCard } from "@/services/index.defs";
import { ValidationRules } from "_P/validate";
import { mask } from "vue-the-mask";
import { CarSerialType } from "@/models/Models";
import LanguageControl from "_P/LanguageControl";

@Component({ directives: { mask } })
export default class CarSerial extends Vue {
    @Prop() card: InsuranceCard;
    @Prop() car: Car;
    Rules = ValidationRules;

    CarSerialTypes = CarSerialType;
    carSerialType: CarSerialType = CarSerialType.vin;
    created() {
        if (this.car.vin) {
            this.carSerialType = CarSerialType.vin;
            this.car.bodyNumber = "";
            this.car.chassisNumber = "";
        } else if (this.car.bodyNumber) {
            this.carSerialType = CarSerialType.body;
            this.car.vin = "";
            this.car.chassisNumber = "";
        } else if (this.car.chassisNumber) {
            this.carSerialType = CarSerialType.chassis;
            this.car.vin = "";
            this.car.bodyNumber = "";
        } else this.carSerialType = CarSerialType.vin;
    }

    get currentSerialValue(): string {
        switch (this.carSerialType) {
        case CarSerialType.body:
            return this.car.bodyNumber;
        case CarSerialType.chassis:
            return this.car.chassisNumber;
        case CarSerialType.vin:
            return this.car.vin;
        default:
            return "";
        }
    }
    get currentLabel(): string {
        switch (this.carSerialType) {
        case CarSerialType.body:
            return "Номер кузова";
        case CarSerialType.chassis:
            return "Номер шасси";
        case CarSerialType.vin:
            return "VIN";
        default:
            return "";
        }
    }

    processInput(
        prop: "carDocSeria" | "carId",
        value,
        conversion: "RusToEn" | "EnToRus"
    ) {
        if (!value) return;
        let result = LanguageControl[conversion](value.toUpperCase());

        if (this.carSerialType == CarSerialType.vin) {
            result = result.replaceAllSubs("O", "0");
            result = result.replaceAllSubs("I", "1");
            result = result.replaceAllSubs("Q", "9");
        }

        if (this.carSerialType == CarSerialType.vin) this.car.vin = result;
        if (this.carSerialType == CarSerialType.body)
            this.car.bodyNumber = result;
        if (this.carSerialType == CarSerialType.chassis)
            this.car.chassisNumber = result;
    }
}
